// extracted by mini-css-extract-plugin
module.exports = {"item":"item___3eJzr","title":"title___UUE7r","value":"value___OgvKv","value_Editable":"value_Editable___1wbxX"};